import React, { Component } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";

interface ModalProps {
  showModal: boolean;
  title: string;
  label: string;
  actionButton: string;
  onAction?: (event: any) => void;
  onClose: (event: any) => void;
  loadingStatus: boolean;
}

// * Modal used for confirmation.
// ! Only meant to return yes(action) / no(cancel)

class JobTitleConfirmModal extends Component<ModalProps, {}> {
  render() {
    return (
      //!!r-18-jw
      //@ts-ignore
      <Modal show={this.props.showModal} onHide={this.props.onClose} centered>
        <Modal.Header>
          <Modal.Title>{this.props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{this.props.label}</Modal.Body>
        <Modal.Footer>
          {!this.props.loadingStatus ? (
            <>
              <Button variant="secondary" onClick={this.props.onClose}>
                Cancel
              </Button>
              <Button variant="danger" onClick={this.props.onAction}>
                {this.props.actionButton}
              </Button>
            </>
          ) : (
            <>
              <Button variant="secondary" disabled>
                Cancel
              </Button>
              <Button variant="danger" disabled>
                <Spinner animation="border" role="status" size="sm"></Spinner>
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

export default JobTitleConfirmModal;
